import { List, ListItem } from '@mui/material';
import DescTooltip from '../components/DescTooltip';
import type { Nullable } from '../types/common/utility';

const TooltipList = ({ items }: TooltipListProps) => {
  if (!items || !items.length) {
    return null;
  }

  return (
    <DescTooltip
      tooltip={
        <List sx={{ listStyleType: 'disc', pl: 2 }}>
          {items.map?.((item) => (
            <ListItem key={item} sx={{ display: 'list-item' }} disablePadding>
              {item}
            </ListItem>
          ))}
        </List>
      }
    />
  );
};

export default TooltipList;

type TooltipListProps = {
  items: Nullable<string[]>;
};
